import {FeatureFlagScope} from './FeatureFlagScope'

export const DefaultFeatureFlags = FeatureFlagScope.create({
  primer_react_css_modules: false,
  primer_react_action_list_item_as_button: false,
})
